import React from "react";
import { FiLogOut } from "react-icons/fi";
import useAuth from "../useAuth";
import PageName from "../Components/global/PageName";
import { FaUserShield, FaEnvelope, FaPhoneAlt, FaCrown } from "react-icons/fa";

export const ProfilePage = () => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    let userRes = window.confirm("Are you sure you want to logout?");
    if (!userRes) return null;
    logout();
  };

  return (
    <div className="min-h-screen pb-12">
      <PageName
        title="Admin Profile"
        subTitle="Manage your account profile and authentication details."
      />

      <div className="max-w-2xl mx-auto px-4 mt-6">
        <div className="bg-white rounded-3xl p-8 border border-slate-200 shadow-sm flex flex-col items-center text-center relative overflow-hidden">
          {/* Header background glow */}
          <div className="absolute top-0 left-0 right-0 h-28 bg-gradient-to-r from-amber-600 to-amber-800 pointer-events-none" />

          {/* User Profile Avatar */}
          <div className="relative z-10 -mt-2 mb-4">
            <div className="w-24 h-24 rounded-full bg-white p-1 shadow-lg">
              <div className="w-full h-full rounded-full bg-amber-100 border-2 border-amber-500 text-amber-800 flex items-center justify-center font-bold text-3xl uppercase">
                {user?.fullName?.[0] || user?.name?.[0] || "A"}
              </div>
            </div>
          </div>

          <h2 className="text-xl font-bold text-slate-900 capitalize">
            {user?.fullName || user?.name || "Administrator"}
          </h2>
          <div className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-800 text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mt-2">
            <FaCrown size={12} /> {user?.userType || "Admin"}
          </div>

          {/* Details Card */}
          <div className="w-full mt-8 bg-slate-50 p-6 rounded-2xl border border-slate-200/80 space-y-4 text-left">
            <div className="flex items-center justify-between py-2 border-b border-slate-200">
              <span className="text-xs font-semibold text-slate-500 flex items-center gap-2">
                <FaUserShield className="text-amber-600" /> Full Name
              </span>
              <span className="text-xs font-bold text-slate-800 capitalize">
                {user?.fullName || user?.name || "N/A"}
              </span>
            </div>

            <div className="flex items-center justify-between py-2 border-b border-slate-200">
              <span className="text-xs font-semibold text-slate-500 flex items-center gap-2">
                <FaEnvelope className="text-amber-600" /> Email Address
              </span>
              <span className="text-xs font-bold text-slate-800">
                {user?.email || "N/A"}
              </span>
            </div>

            <div className="flex items-center justify-between py-2 border-b border-slate-200">
              <span className="text-xs font-semibold text-slate-500 flex items-center gap-2">
                <FaPhoneAlt className="text-amber-600" /> Mobile Number
              </span>
              <span className="text-xs font-bold text-slate-800">
                {user?.mobileNo || "N/A"}
              </span>
            </div>

            <div className="flex items-center justify-between py-2">
              <span className="text-xs font-semibold text-slate-500 flex items-center gap-2">
                <FaCrown className="text-amber-600" /> System Role
              </span>
              <span className="text-xs font-bold text-amber-700 uppercase">
                {user?.userType || "Admin"}
              </span>
            </div>
          </div>

          {/* Action buttons */}
          <button
            onClick={handleLogout}
            className="mt-8 flex items-center justify-center gap-2 px-8 py-3 bg-red-600 hover:bg-red-700 text-white text-xs font-semibold uppercase tracking-wider rounded-xl shadow-md shadow-red-600/20 transition-all"
          >
            <span>Log Out Account</span>
            <FiLogOut size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};
